import { faCalendar, faClock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { classNames } from '../../../helpers/classNames';
import NavDataInterface from '../../../interfaces/NavDataInterface';
import ButtonVariant from '../../ButtonVariant';
import styles from './style.module.scss';

interface Props {
    item: NavDataInterface;
    selected?: string;
    onClick?: (event: { event: MouseEvent; value: NavDataInterface }) => void;
}

function SideNavItem(props: Props) {
    const { item, selected, onClick } = props;

    const handleClick = (event: MouseEvent) => {
        if (onClick) {
            onClick({
                event,
                value: item,
            });
        }
    };
    return (
        <div
            className={classNames([
                styles.sideNavBtn,
                selected && item.id.includes(selected) && selected.length > 0
                    ? styles.selected
                    : '',
            ])}
            key={item.label + '_' + item.id}
        >
            <ButtonVariant
                variant={item.variant}
                link={item.link}
                key={item.id || item.label}
                onClick={handleClick}
            >
                {item.icon && (
                    <FontAwesomeIcon icon={item.icon} className={styles.icon} />
                )}
                <span className={styles.btn}>
                    <label className={styles.label}>{item.label}</label>
                    <span className={styles.subText}>
                        {!!item.subLabel && (
                            <label className={styles.subLabel}>
                                {item.subLabel}
                            </label>
                        )}
                        {!!item.date && (
                            <div className={styles.dateContainer}>
                                <label className={styles.date}>
                                    <FontAwesomeIcon icon={faCalendar} />
                                    <span>
                                        {new Date(
                                            item.date
                                        ).toLocaleDateString()}
                                    </span>
                                </label>
                                <label className={styles.date}>
                                    <FontAwesomeIcon icon={faClock} />
                                    <span>
                                        {new Date(
                                            item.date
                                        ).toLocaleTimeString()}
                                    </span>
                                </label>
                            </div>
                        )}
                    </span>
                </span>
            </ButtonVariant>
        </div>
    );
}

export default SideNavItem;
